import { useAppSelector } from 'app/hooks';
import { differenceInMinutes } from 'date-fns';
import { durationToTime, getAirportTimezone, getDate, getTimeInTimezone } from 'helper/date';
import { useTranslation } from 'react-i18next';
import { complementaryFormDataState, flightFormDataState } from 'store/flight/flightSlice';
import { isLTRState } from 'store/options/optionsSlice';
import * as S from './Segment.styles';
import { FlightBookSidebarSegmentProp } from './segment.interface';

const FlightBookSidebarSegment = ({ flightSegment, index }: FlightBookSidebarSegmentProp) => {
  const { t } = useTranslation();
  const isLTR = useAppSelector(isLTRState);
  const { departureText, destinationText } = useAppSelector(complementaryFormDataState);
  const { departure, destination } = useAppSelector(flightFormDataState);
  const flightStops =
    flightSegment.length === 1
      ? t('pages.services.flight.constants.stops.direct')
      : flightSegment.length === 2
      ? t('pages.services.flight.constants.stops.oneStop')
      : t('pages.services.flight.constants.stops.moreThanOneStop', {
          count: flightSegment.length,
        });
  return (
    <>
      <S.Header>
        <S.Title>
          {t('pages.services.flight.pages.book.sections.passengers.sections.sidebar.sections.leg.title', {
            time: getTimeInTimezone(
              flightSegment[0].departureDateTime,
              getAirportTimezone(index == 0 ? departure : destination)
            ),
            date: getDate(flightSegment[0].departureDateTime),
          })}
        </S.Title>
      </S.Header>
      <S.Content>
        <S.LocationWrapper>
          <S.LocationIconWrapper $isLTR={isLTR}>
            <S.LocationIcon style={{ backgroundImage: `url(/passenger/images/fromToIcon.png)` }} />
          </S.LocationIconWrapper>
          <S.Location>
            {index == 0 ? departureText : destinationText} ({index == 0 ? departure : destination})
          </S.Location>
          <S.LocationEnd>
            {index == 0 ? destinationText : departureText} ({index == 0 ? destination : departure})
          </S.LocationEnd>
        </S.LocationWrapper>
        <S.TinyText>
          {t('pages.services.flight.pages.book.sections.passengers.sections.sidebar.sections.leg.duration')}:{' '}
          {durationToTime(
            differenceInMinutes(
              flightSegment[flightSegment.length - 1].arrivalDateTime,
              flightSegment[0].departureDateTime
            )
          )}{' '}
          / {flightStops}
        </S.TinyText>
      </S.Content>
    </>
  );
};
export default FlightBookSidebarSegment;
